import { useState, useEffect } from "react";
import axios from "axios";
import { Scales } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ComparativaBaremos = ({ cuantia, tipoProcedimiento }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!cuantia || cuantia <= 0) return;
    const fetchComparativa = async () => {
      try {
        const response = await axios.get(`${API}/comparativa?cuantia=${cuantia}&tipo_procedimiento=${tipoProcedimiento}`);
        setData(response.data);
      } catch (error) {
        console.error('Error fetching comparativa:', error);
      }
    };
    fetchComparativa();
  }, [cuantia, tipoProcedimiento]);

  if (!data) return null;

  const items = [
    { label: "Criterio A (ICAM)", value: data.icam.honorarios, nota: data.icam.nota, accent: true },
    { label: "Criterio B (ICAB)", value: data.icab.honorarios, nota: data.icab.grado ? `Grado ${data.icab.grado} (x${data.icab.factor})` : "" },
  ];

  if (data.mercado) {
    items.push(
      { label: "Mercado: Asesoria", value: data.mercado.asesoria, nota: "" },
      { label: "Mercado: Bufete", value: data.mercado.bufete, nota: "" },
      { label: "Mercado: Low cost", value: data.mercado.low_cost, nota: "" }
    );
  }

  const maxVal = Math.max(...items.map(i => i.value || 0));

  return (
    <div className="bg-white border border-[#171717] rounded-none p-6 shadow-[4px_4px_0px_0px_rgba(23,23,23,1)]" data-testid="comparativa-baremos">
      <div className="flex items-center gap-3 mb-4">
        <Scales size={24} weight="regular" className="text-[#8B1A1A]" />
        <h3 className="text-lg font-semibold text-[#0A0A0A]" style={{ fontFamily: 'Playfair Display, serif' }}>
          Comparativa de baremos
        </h3>
      </div>
      
      <div className="space-y-3">
        {items.map((item, idx) => (
          <div key={idx} className="group">
            <div className="flex justify-between items-baseline mb-1">
              <span className={`text-sm ${item.accent ? 'font-semibold text-[#0A0A0A]' : 'text-[#525252]'}`} style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
                {item.label}
              </span>
              <span className={`font-mono text-sm ${item.accent ? 'font-bold text-[#8B1A1A]' : 'text-[#0A0A0A]'}`} style={{ fontFamily: 'IBM Plex Mono, monospace' }}>
                {item.value?.toLocaleString('es-ES', { minimumFractionDigits: 2 })}€
              </span>
            </div>
            <div className="h-2 bg-[#E5E5E2] rounded-none overflow-hidden">
              <div
                className={`h-full transition-all duration-500 ${item.accent ? 'bg-[#8B1A1A]' : idx === 1 ? 'bg-[#525252]' : 'bg-[#A3A3A3]'}`}
                style={{ width: `${maxVal > 0 ? (item.value / maxVal) * 100 : 0}%` }}
              />
            </div>
            {item.nota && (
              <p className="text-[10px] text-[#A3A3A3] mt-0.5 font-mono" style={{ fontFamily: 'IBM Plex Mono, monospace' }}>{item.nota}</p>
            )}
          </div>
        ))}
      </div>
      
      <p className="text-[10px] text-[#A3A3A3] mt-4 text-center border-t border-[#E5E5E2] pt-3" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
        Comparativa orientativa para cuantia de {cuantia?.toLocaleString('es-ES')}€. Los honorarios son libres.
      </p>
    </div>
  );
};

export default ComparativaBaremos;
